import * as React from 'react'
import {Box} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";


export default function discountColumn() {
    return {
        name: 'avgDiscount', label: 'Avg. Discount',
        options: {
            customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                {formatPercentage(value, { decimals: 2 })}
            </Box>
        }
    }
}